// #TODO 30-04-2018_FG Terminer les interfaces

// Angular
import { Injectable } from '@angular/core';

import _cloneDeep from 'lodash-es/cloneDeep';

// Rxjs
import { BehaviorSubject ,  Observable } from 'rxjs';

// Afidium
import { IView } from '../models/view';

@Injectable()
export class ViewService {
    public initialView: IView = {
        searchForm: true,
        resume: false,
        hotelsList: false,
        map: false,
        list: true,
        loaders: {
            getQuotation: false,
            getOtherRooms: false,
            getHostRooms: false,
            searchHotels: false
        }
    };

    public view: BehaviorSubject<IView> = new BehaviorSubject(this.initialView);

    public getView (): Observable<IView> {
        return this.view.asObservable();
    }

    public changeView (view: string | IView, value?: boolean): void {
        let udpdatedView: IView = _cloneDeep(this.view.getValue());

        if (typeof view === 'object') {
            udpdatedView = {
                ...udpdatedView,
                ...view
            };
        } else {
            udpdatedView[view] = value;
        }

        this.view.next(udpdatedView);
    }
}
